export default __webpack_public_path__ + "static/media/innovateColored.bb3e76cb.png";